import fetchClient from "api/client";
import SCHEDULED_REPORTS_ENDPOINT from "./scheduledReportsEndpoint";

/**
 * @description PATCH /api/reports-schedule
 * @param {object} payload - The payload object.
 * @param {object} payload.body - The body to update on the rule.
 * @returns {Promise}
 */
export default function updateScheduledReport({ reportId, body }) {
  if (!reportId) {
    return Promise.reject(new Error("Report ID is required for updating."));
  }

  const url = `${SCHEDULED_REPORTS_ENDPOINT}/${reportId}`;

  return fetchClient.patch(url, { body });
}
